import { SalaryAction, SalaryActionTypes, SalaryState } from '../../types/salary'

const initialState = {
  tableValue: [],
  editedTableValue: [],
  createdTransferValue: [],
  salaryList: [],
  salaryListError: true,
  searchbyfin: false,
}

const salaryReducer = (state = initialState, action: SalaryAction): SalaryState => {
  switch (action.type) {
    case SalaryActionTypes.FILL_TABLE:
      return {
        ...state,
        tableValue: action.payload,
      };
    case SalaryActionTypes.EDIT_TABLE:
      return {
        ...state,
        editedTableValue: action.payload,
      };
    case SalaryActionTypes.SET_OPTION:
      return {
        ...state,
        selectedItem: action.payload,
      };
    case SalaryActionTypes.CREATE_TRANSFER:
      return {
        ...state,
        createdTransferValue: action.payload,
      };
    case SalaryActionTypes.GET_SALARY_LIST:
      return {
        ...state,
        salaryListError: false,
        searchbyfin: false,
      };
    case SalaryActionTypes.GET_SALARY_LIST_SUCCESS:
      return {
        ...state,
        salaryList: action.payload,
        salaryListError: false,
      };
    case SalaryActionTypes.GET_SALARY_LIST_ERROR:
      return {
        ...state,
        salaryList: [],
        salaryListError: true,
      };
    case SalaryActionTypes.GET_SALARY_LIST_WITH_FIN:
      return {
        ...state,
        salaryListError: false,
        searchbyfin: true,
      };
    case SalaryActionTypes.CLEAR_SALARY_LIST:
      return {
        ...state,
        tableValue: [],
        editedTableValue: [],
        createdTransferValue: [],
        salaryList: [],
        salaryListError: true,
        searchbyfin: false,
      };
    default:
      return state;
  }
};

export default salaryReducer